import { find, bindAll, isEqual } from 'lodash';
import styled from "styled-components";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AlertIcon, AlertNotification, Button, Dropdown, colors } from '@commonsku/styles';

import config from '../config';
import LabelledInput from './LabelledInput';
import LabelledSelect from './LabelledSelect';
import LabelledAddress from './LabelledAddress';
import LabelledContact from './LabelledContact';
import LabelledTextArea from './LabelledTextArea';
import LabelledRadio from './LabelledRadio';
import LabelledCheckbox from './LabelledCheckbox';
import LabelledControl from './LabelledControl';
import ItemList from './ItemList';
import RefundCheckoutsPopup from './RefundCheckoutsPopup';
import OrderSummary from './OrderSummary';
import ProjectMarginSummary from './ProjectMarginSummary';
import OrderMarginSummary from './OrderMarginSummary';
import TaxSelect from './TaxSelect';
import { isAvalaraOrder } from '../helpers/order';
import { SanmarNotificationBar } from './SanmarModal';

import { getOrderByNumber, getAddress, getContact } from '../selectors';
import { getStatusOptions, getServiceOptions, getBillingAddressOptions, getShippingAddressOptions, getContactOptions, getCurrencyOptions, getTermsOptions, getTaxOptions } from '../selectors/dropdowns';

import { updateOrder, updateOrderContact, updateOrderAddress, createLoadOrder, createLoadPartialList } from '../actions/order';
import { createSplitShipPopup } from '../actions/popup';
import { createRemovePartials } from '../actions/shop';
import { FLAG_COMMONSKU_PAYMENTS, FLAG_COMMONSKU_PAYMENTS_QBO_REFUNDS_UI, REFUNDS_TAB_STATUSES } from './admin-new/CreditCardIntegration';
import { createAddDepositInvoice, createUpdateDepositInvoice, createDeleteDepositInvoice } from '../actions/deposit_invoice';
import CREDIT_CARD_PROVIDERS from '../constants/CreditCardProviders';
import { createUpdateDisplayItemSummaryView, createUpdateDisplayItemSummaryShowActive, createUpdateDisplayItemSummaryTab, createUpdateCollapseOrderInfo } from '../actions/display';
import { getOrderTypeLabel } from '../helpers/order';
import { ReportProvider } from "./report/report_context";
import ReportTable from "./report/table/ReportTable";
import Pagination from "./report/table/Pagination";
import Loading from "./report/Loading";
import { getReportConfig } from "./report/config";
import withReducers from '../store/withReducers';
import SplitShipSlice, { selectSplitShip } from '../redux/splitShip';

import {
  createAddAddressPopup,
  createAddContactPopup,
  createPartialPopup,
  createValidateConfirmationPopup,
  createErrorPopup,
  createNoticePopup,
  closePopup,
} from '../actions/popup';

import { oauth, openWindowWithPost, getIdentityUtils } from '../utils';
import PartialList from './PartialList';
import AvalaraCategorySelect from './avalara/AvalaraCategorySelect';
import { ExportViewerPortal, ExportViewer } from './export-report/ExportViewer';
import ReactTooltip from './helpers/ReactTooltip';
import { Span } from './helpers/Typography';
import { ExportViewerPopup } from './export-report/ExportViewerPopup';
import OrderCreditCardFeeEditHandle from './OrderCreditCardFeeEditHandle';
import { PresentationStyleRadioGroup, TemplatesOption } from './PresentationStyleRadioGroup';
import ExportToShipStationPopup from './shop/popups/ExportToShipStationPopup';
import ExportToShipStationStatusPopup from './shop/popups/ExportToShipStationStatusPopup';
import UpgradeProductPopup from './UpgradeProductPopup';
import { getUpgradePromoStandardsProductTaskStatus } from '../actions/item';
import { getConvertibleProducts, removeConvertible } from '../redux/convertibleProducts';
import { toast } from 'react-toastify';

const ReportTableContainer = styled.div`
  position: relative;
`;

const RefundCheckoutsButton = styled(Button)`
  margin: 15px 10px 0px 0px;
  float: right;
`;

const RefundTabAlertIcon = styled(AlertIcon)`
  margin-left: 4px;
  vertical-align: middle;
`;

const PRESENTATION_VIEW_TYPES = [
  { key: 'SHOP_DESIGN', value: 'Templates', children: TemplatesOption },
  { key: 'LIST', value: 'List' },
  { key: 'GALLERY', value: 'Gallery' },
  { key: 'SMART', value: 'Smart Gallery' },
  { key: 'TILE', value: 'Tiles' },
];

const INVOICE_VIEW_TYPES = [
  { key: 'DETAIL', value: 'Detail' },
  { key: 'SUMMARY', value: 'Summary' }
];

// POST /forward-payments/refund always answers 200; per-payment outcome lives in json.results.
// These outcomes persist (or already persisted) a refunds row, so the Refunds tab badge/tooltip/
// Retry already surfaces them. Only an outcome that never reaches a row needs a popup error.
const REFUND_TRACKED_OUTCOMES = [
  'REFUND_PENDING', 'REFUNDED', 'VOIDED', 'FAILED',
  'ALREADY_IN_PROGRESS', 'ALREADY_REFUNDED', 'ALREADY_VOIDED',
];

// const ORDER_DATE_FIELD = [
//   'date_orderdate', 'date_expiry', 'date_inhandsdate'
// ];

class ProjectOrder extends Component {

  constructor(props) {
    super(props);

    this.state = {
      exportTaskIds: [],
      order: Object.assign({ loaded: false }, props.order),
      selected_partials: [],
      selected_refunds: [],
      in_aggregating: false,
      partials_loaded: false,
      exportingPdf: false,
      showPopup: '',
      exportShipstationErrorMessage: null,
      getStoresError: false,
      upgradeProduct: null,
      upgradingByItemId: {},
      upgradeFailedByItemId: {},
      refundingCheckouts: false,
      refundCheckoutsError: null,
      retryingRefunds: false,
      retryRefundsError: null,
    };
    // We would normally use useMemo() but this is a class component
    this.creditMemoReportFilter = { invoice_id: props.order?.order_id };
    this.reportConfig = getReportConfig("INVOICE-CREDIT-MEMOS");

    bindAll(this, ['checkBulkUpdateMarginStatus', 'onChangeOrder', 'hasCapability', 'handleToggleCollapse', 'exportPartialsCSV', 'exportPartialsPDF', 'handleLoadPartials', 'handleClickPartial', 'handleSelectAllPartials', 'handleClickRefund', 'handleSelectAllRefunds', 'handleRemovePartials', 'handleRefundCheckouts', 'handleRetryFailedRefunds', 'handleShowPopup', 'handleUpgradeQueued', 'bootstrapUpgradeStatuses', 'ensureUpgradePolling', 'pollUpgrades']);
    this.didBootstrapForOrderId = null;
    this.isBootstrappingUpgradeStatuses = false;
  }

  componentDidMount() {
    if (!this.props.order.loaded) {
      this.props.loadOrder(this.props.order.order_id);
    }

    if (this.props.order.is_aggregate == 1 && this.props.order.in_aggregating == 1) {
      this.props.onCreateNoticePopup();
      this.checkShopAggregateStatus();
    }

    if (this.props.order.bulk_update_margin_count !== 0 && this.props.order.locked) {
      this.checkBulkUpdateMarginStatus();
    }

    if (this.props.hasPSUpgradeProductEnabled) {
      this.maybeBootstrapAndFetch();
    }
  }

  UNSAFE_componentWillMount() {
    this.setState({ loaded: false });
    const sales_orders = this.props.project.sales_orders || [];
    const invoices = this.props.project.invoices || [];

    Promise.all([
      ...sales_orders.map(o =>  this.props.loadOrder(o.order_id, true)),
      ...invoices.map(o => this.props.loadOrder(o.order_id, true)),
    ])
    .then(() => {
      this.setState({ loaded: true });
    })
    .catch((error) => {
      console.error('Failed to load orders:', error);
    });
  }

  componentDidUpdate(prevProps) {
    const prevOrder = prevProps.order;
    const { order, loadOrder } = this.props;
    if (order.order_id !== prevOrder.order_id) {
      this.creditMemoReportFilter = { invoice_id: order.order_id };
    }
    if (!isEqual(order, prevOrder)) {
      this.setState({
        order: Object.assign({ loaded: false }, order)
      });
      if (order.order_id !== prevOrder.order_id || !order.loaded) {
        loadOrder(order.order_id);
      }
      if (this.props.hasPSUpgradeProductEnabled) {
        this.maybeBootstrapAndFetch(prevProps);
      }
    }
  }

  componentWillUnmount() {
    if (this.upgradePollInterval) clearInterval(this.upgradePollInterval);
  }

  bootstrapUpgradeStatuses = async () => {
    const order = this.props.order;
    if (!order?.order_id || !order?.items?.length) return { upgradingByItemId: {}, upgradeFailedByItemId: {} };

    const order_id = order.order_id;

    const candidates = order.items.filter(
      i => i.copied_from !== 'ps-products' && i.promo_api_name
    );

    if (candidates.length === 0) return { upgradingByItemId: {}, upgradeFailedByItemId: {} };

    const results = await Promise.allSettled(
      candidates.map(i =>
        this.props.onGetUpgradePromoStandardsProductTaskStatus(i.item_id, order_id)
      )
    );

    const upgradingByItemId = {};
    const upgradeFailedByItemId = {};

    results.forEach((r, idx) => {
      if (r.status !== 'fulfilled') return;
      const up = r.value?.upgrade;
      if (!up?.has_task) {
        return;
      }

      const item_id = candidates[idx].item_id;
      if (up.status === 'PENDING' || up.status === 'PROCESSING') {
        upgradingByItemId[item_id] = {
          order_id,
          status: up.status,
          process_step: up.process_step,
          error_message: up.error_message,
        };
      }

      if (up.status === 'FAILED') {
        upgradeFailedByItemId[item_id] = {
          order_id,
          status: up.status,
          process_step: up.process_step,
          error_message: up.error_message,
        };
      }
    });

    const hasUpgrading = Object.keys(upgradingByItemId).length > 0;
    const hasFailed = Object.keys(upgradeFailedByItemId).length > 0;

    if (hasUpgrading || hasFailed) {
      this.setState({
        ...(hasUpgrading ? { upgradingByItemId } : null),
        ...(hasFailed ? { upgradeFailedByItemId } : null),
      }, hasUpgrading ? this.ensureUpgradePolling : undefined);
    }

    return { upgradingByItemId, upgradeFailedByItemId };
  };

  maybeBootstrapAndFetch = async (prevProps = null) => {
    const order = this.props.order;
    const { convertibleProducts, convertibleProductsLoading } = this.props;
    if (!order?.loaded || !order?.order_id || !Array.isArray(order.items)) return;
    if (this.isBootstrappingUpgradeStatuses) return;
    if (this.didBootstrapForOrderId === order.order_id) return;
    this.isBootstrappingUpgradeStatuses = true;
    try {
      const { upgradingByItemId: upgrading } = await this.bootstrapUpgradeStatuses();

      if (!convertibleProductsLoading && convertibleProducts.length === 0) {
        const nonPSItems = order.items
          .filter(item => item.copied_from !== 'ps-products' && item.promo_api_name)
          .filter(item => !(config.blankSupplierPromoApiNames.includes(item.promo_api_name) && item.item_locations?.length > 0))
          .filter(i => !['PENDING', 'PROCESSING'].includes(upgrading[i.item_id]?.status))
          .map(item => ({
            promo_api_name: item.promo_api_name,
            sku: item.item_sku,
            currency_id: item.currency_id,
            hasItemLocations: item.item_locations.length > 0
          }));

        if (nonPSItems.length > 0) {
          await this.props.fetchConvertibleProducts(nonPSItems);
        }
      }

      this.didBootstrapForOrderId = order.order_id;
    } finally {
      this.isBootstrappingUpgradeStatuses = false;
    }
  };

  handleUpgradeQueued = ({ order_id, item_id }) => {
    this.setState(prev => {
      const nextFailed = { ...prev.upgradeFailedByItemId };
      delete nextFailed[item_id];

      return {
        upgradingByItemId: {
          ...prev.upgradingByItemId,
          [item_id]: { order_id, status: 'PENDING' },
        },
        upgradeFailedByItemId: nextFailed,
      };
    }, this.ensureUpgradePolling);
  };

  ensureUpgradePolling = () => {
    if (this.upgradePollInterval) return;
    this.upgradePollInterval = setInterval(this.pollUpgrades, 10000);
  };

  clearUpgradePollInterval = () => {
    if (this.upgradePollInterval) {
      clearInterval(this.upgradePollInterval);
      this.upgradePollInterval = null;
    }
  };

  removeUpgrading = (item_id) => {
    this.setState(prev => {
      const next = { ...prev.upgradingByItemId };
      delete next[item_id];
      return { upgradingByItemId: next };
    }, () => {
      // stop polling when empty
      if (Object.keys(this.state.upgradingByItemId).length === 0) {
        this.clearUpgradePollInterval();
      }
    });
  };

  updateUpgrading = (item_id, patch) => {
    this.setState(prev => ({
      upgradingByItemId: {
        ...prev.upgradingByItemId,
        [item_id]: {
          ...prev.upgradingByItemId[item_id],
          ...patch,
        },
      },
    }));
  };

  pollUpgrades = async () => {
    const entries = Object.entries(this.state.upgradingByItemId);
    if (entries.length === 0) {
      this.clearUpgradePollInterval();
      return;
    }

    await Promise.allSettled(entries.map(async ([item_id, info]) => {
      try {
        const json = await this.props.onGetUpgradePromoStandardsProductTaskStatus(item_id, info.order_id);
        const up = json?.upgrade;
        if (!up?.has_task) {
          this.removeUpgrading(item_id);
          return;
        }

        if (up.status === 'PENDING' || up.status === 'PROCESSING') {
          this.updateUpgrading(item_id, {
            status: up.status,
            process_step: up.process_step,
            error_message: up.error_message,
          });
          return;
        }

        if (up.status === 'FAILED') {
          this.setState(prev => ({
            upgradeFailedByItemId: {
              ...prev.upgradeFailedByItemId,
              [item_id]: {
                order_id: info.order_id,
                status: up.status,
                process_step: up.process_step,
                error_message: up.error_message,
              },
            },
          }));
          this.removeUpgrading(item_id);
          return;
        }

        if (up.status === 'SUCCESS') {
          // 1) remove from polling list
          this.removeUpgrading(item_id);

          // 2) remove convertible product from redux without refetch
          const item = json?.item;
          const label = item?.item_name || item?.item_sku;
          if (label) {
            toast.success(`Upgrade completed for ${label}`);
          }
          const deletedItemId = json?.deleted_item_id;

          const stillUsed = this.props.order.items.some(
            i => i.item_sku === item?.item_sku
              && i.promo_api_name === item?.promo_api_name
              && i.copied_from !== 'ps-products'
              && i.item_id !== deletedItemId
          );
          if (item?.promo_api_name && item?.item_sku && !stillUsed) {
            this.props.removeConvertibleByKey(item.promo_api_name, item.item_sku);
          }
          return;
        }
      } catch (e) {
        this.removeUpgrading(item_id);
        return;
      }
    }));
  };


  checkBulkUpdateMarginStatus(onSuccess) {
    const { order, loadOrder } = this.props;

    const interval = setInterval(async () => {
      const result = await loadOrder(order.order_id, true);
      if (result.payload.order.bulk_update_margin_count === 0) {
        clearInterval(interval);
        if (onSuccess) {
          onSuccess();
        }
      }
    }, 5000);
  }

  checkShopAggregateStatus() {
    const { order, project } = this.props;

    this.interval = setInterval(function () {
      return oauth('GET', `shop/${order.shop_id}`, {}).then(({ json }) => {
        if (json.shop.in_aggregating == 0) {
          window.location = `/project/${project.job_number}/sales-order/${order.form_number}`;
        }
      });
    }, 15000);
  }

  onChangeOrder(field) {
    return value => {
      this.setState({
        order: Object.assign({}, this.state.order, { [field]: value })
      });
    };
  }

  handleToggleCollapse(e) {
    this.props.onUpdateCollapsed(this.state.order.order_id, !this.props.collapsed);
  }

  handleShowPopup = (popup, errorMessage = null, getStoresError = false) => {
    this.setState({ showPopup: popup, exportShipstationErrorMessage: errorMessage, getStoresError: getStoresError });
  };

  renderBasicInfo() {
    const { order } = this.state;
    const { statuses, onUpdateOrder, project } = this.props;
    const locked = 1 == order.locked;

    return (
      <div>
        <div className="small-12 large-3 large-push-9 columns">
          <a className="hollow button trigger-button" style={{ float: 'right' }} onClick={this.handleToggleCollapse}>+ Expand Info</a>
        </div>
        <LabelledSelect className="small-12 medium-6 large-3 large-pull-3 columns" label="Status" labelStyle={{ lineHeight: 1.55 }} value={order.status_id} options={statuses} onChange={onUpdateOrder(order.order_id, 'status_id', order.status_id)} disabled={locked && !project.is_pod} />
        <LabelledInput className="small-12 medium-6 large-3 large-pull-3 columns end" label={`${getOrderTypeLabel(order)} Date`} type="date" value={order.date_orderdate} onChange={this.onChangeOrder('date_orderdate')} onBlur={onUpdateOrder(order.order_id, 'date_orderdate', order.date_orderdate)} disabled={locked} />
      </div>
    );
  }

  renderTaxInput() {
    const { project, onUpdateOrder } = this.props;
    const { order } = this.state;
    return [
      <LabelledControl key="default_tax" className="small-12 medium-6 large-3 columns" label="Default Tax">
        <TaxSelect
          value={order.tax_id} zip2tax={1 == project.zip2tax} disabled={order.locked == 1}
          onChange={onUpdateOrder(order.order_id, 'tax_id', order.tax_id)} avalara={true}
        />
      </LabelledControl>,
      isAvalaraOrder(order) && <LabelledControl
        key="avalara_tax" className="small-12 medium-6 large-3 columns" label="Default Avalara Category"
      >
        <AvalaraCategorySelect
          value={order.default_avalara_category_id}
          onChange={onUpdateOrder(
            order.order_id, 'default_avalara_category_id',
            order.default_avalara_category_id
          )}
        />
      </LabelledControl>,
    ];
  }

  renderPresentationInfo() {
    const { order } = this.state;
    const {
      project,
      billing_contact,
      contacts,
      statuses,
      currencies,
      onUpdateOrder,
      onUpdateBillingContact,
      onAddContact,
    } = this.props;
    const locked = 1 == order.locked;
    const intro = order && order.introduction ? (order.introduction).replace(/\<br \/?>/g, "") : '';
    const presentationViewTypes = PRESENTATION_VIEW_TYPES;

    return (
      <div>
        <ReactTooltip id="design-beta-tooltip" type="success">
          <div>
            <Span bold style={{ color: 'var(--color-green-90)' }}>
              Unlock the "Design" tab for new presentation templates and customizations!
            </Span>
          </div>
        </ReactTooltip>

        <div className="small-12 large-3 large-push-9 columns">
          <a className="hollow button trigger-button" style={{ float: 'right' }} onClick={this.handleToggleCollapse}>- Collapse Info</a>
        </div>
        <LabelledSelect className="small-12 medium-6 large-3 large-pull-3 columns" labelStyle={{ lineHeight: 1.55 }} label="Status" value={order.status_id} options={statuses} onChange={onUpdateOrder(order.order_id, 'status_id', order.status_id)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 large-pull-3 columns" label="Presentation Date" type="date" value={order.date_orderdate} onChange={this.onChangeOrder('date_orderdate')} onBlur={onUpdateOrder(order.order_id, 'date_orderdate', order.date_orderdate)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 large-pull-3 columns" label="In Hands Date" type="date" value={order.date_inhandsdate} onChange={this.onChangeOrder('date_inhandsdate')} onBlur={onUpdateOrder(order.order_id, 'date_inhandsdate', order.date_inhandsdate)} disabled={locked} />
        <LabelledTextArea className="small-12 columns" label="Introduction" value={intro} onChange={this.onChangeOrder('introduction')} onBlur={onUpdateOrder(order.order_id, 'introduction', order.introduction)} disabled={locked} style={{ minWidth: '100%' }} />
        <LabelledContact
          className="small-12 medium-6 large-3 columns"
          label="Client Contact"
          contact={billing_contact}
          onChangeContact={onUpdateBillingContact(order.order_id, order.billing_contact_id, order.billing_address_id)}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'billing_contact_id', order.billing_contact_id)}
        />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Expiry Date" type="date" value={order.date_expiry} onChange={this.onChangeOrder('date_expiry')} onBlur={onUpdateOrder(order.order_id, 'date_expiry', order.date_expiry)} disabled={locked} />
        <LabelledSelect className="small-12 medium-6 large-2 columns" label="Currency" value={order.currency_id} options={currencies} onChange={onUpdateOrder(order.order_id, 'currency_id', order.currency_id)} disabled={true} />
        <LabelledCheckbox className="small-12 medium-6 large-3 columns end" label="Hide Pricing" value={order.hide_pricing} onChange={onUpdateOrder(order.order_id, 'hide_pricing', order.hide_pricing)} />
        <div className="small-12 columns">
          <PresentationStyleRadioGroup
            value={order.view_type}
            options={presentationViewTypes}
            onChange={onUpdateOrder(order.order_id, 'view_type', order.view_type)}
            disabled={locked}
            showDesignTabInfo={order.view_type === 'SHOP_DESIGN'}
          />
        </div>
      </div>
    );
  }

  renderEstimateInfo() {
    const { order } = this.state;
    const {
      project,
      billing_address,
      billing_contact,
      shipping_address,
      shipping_contact,
      shippingAddresses,
      billingAddresses,
      contacts,
      statuses,
      currencies,
      terms,
      onUpdateOrder,
      onUpdateBillingContact,
      onUpdateShippingContact,
      onUpdateShippingAddress,
      onAddAddress,
      onAddContact,
    } = this.props;
    const locked = 1 == order.locked;
    const intro = order && order.introduction ? (order.introduction).replace(/\<br \/?>/g, "") : '';

    return (
      <div>
        <div className="small-12 large-3 large-push-9 columns">
          <a className="hollow button trigger-button" style={{ float: 'right' }} onClick={this.handleToggleCollapse}>- Collapse Info</a>
        </div>
        <LabelledSelect className="small-12 medium-6 large-3 large-pull-3 columns" label="Status" labelStyle={{ lineHeight: 1.55 }} value={order.status_id} options={statuses} onChange={onUpdateOrder(order.order_id, 'status_id', order.status_id)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 large-pull-3 columns" label="Estimate Date" type="date" value={order.date_orderdate} onChange={this.onChangeOrder('date_orderdate')} onBlur={onUpdateOrder(order.order_id, 'date_orderdate', order.date_orderdate)} disabled={locked} />
        <LabelledTextArea className="small-12 columns" label="Introduction" value={intro} onChange={this.onChangeOrder('introduction')} onBlur={onUpdateOrder(order.order_id, 'introduction', order.introduction)} disabled={locked} style={{ minWidth: '100%' }} />
        <LabelledAddress
          className="small-12 medium-6 large-3 columns"
          label="Billing Address"
          address={billing_address}
          contact={billing_contact}
          onChangeContact={onUpdateBillingContact(order.order_id, order.billing_contact_id, order.billing_address_id)}
          onChangeAddress={onUpdateOrder(order.order_id, 'billing_address_id', order.billing_address_id)}
          addresses={billingAddresses}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddAddress={onAddAddress(order.order_id, 'billing_address_id', order.billing_address_id, 'BILLING')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'billing_contact_id', order.billing_contact_id)}
        />
        <LabelledAddress
          className="small-12 medium-6 large-3 columns"
          label="Main Shipping Address"
          address={shipping_address}
          contact={shipping_contact}
          onChangeContact={onUpdateShippingContact(order.order_id, order.shipping_contact_id, order.shipping_address_id)}
          onChangeAddress={onUpdateShippingAddress(order.order_id, order.shipping_address_id)}
          addresses={shippingAddresses}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddAddress={onAddAddress(order.order_id, 'shipping_address_id', order.shipping_address_id, 'SHIPPING')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'shipping_contact_id', order.shipping_contact_id)}
        />
        <LabelledSelect className="small-12 medium-6 large-3 columns" label="Terms" value={order.terms_id} options={terms} onChange={onUpdateOrder(order.order_id, 'terms_id', order.terms_id)} disabled={locked} />
        <LabelledSelect className="small-12 medium-6 large-3 columns" label="Currency" value={order.currency_id} options={currencies} onChange={onUpdateOrder(order.order_id, 'currency_id', order.currency_id)} disabled={true} />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="In Hands Date" type="date" value={order.date_inhandsdate} onChange={this.onChangeOrder('date_inhandsdate')} onBlur={onUpdateOrder(order.order_id, 'date_inhandsdate', order.date_inhandsdate)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Default Margin" type="text" disabled={true} value={order.default_margin} onBlur={onUpdateOrder(order.order_id, 'default_margin', order.default_margin)} />
        {this.renderTaxInput()}
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Customer PO" type="text" value={order.customer_po} onBlur={onUpdateOrder(order.order_id, 'customer_po', order.customer_po)} onChange={this.onChangeOrder('customer_po')} disabled={locked} />
      </div>
    );
  }

  renderSalesOrderInfo() {
    const { order } = this.state;
    const {
      project,
      billing_address,
      billing_contact,
      shipping_address,
      shipping_contact,
      shippingAddresses,
      billingAddresses,
      contacts,
      statuses,
      currencies,
      terms,
      onUpdateOrder,
      onUpdateBillingContact,
      onUpdateShippingContact,
      onUpdateShippingAddress,
      onAddAddress,
      onAddContact,
    } = this.props;
    const locked = 1 == order.locked;
    const intro = order && order.introduction ? (order.introduction).replace(/\<br \/?>/g, "") : '';

    return (
      <div>
        <div className="small-12 large-3 large-push-9 columns">
          <a className="hollow button trigger-button" style={{ float: 'right' }} onClick={this.handleToggleCollapse}>- Collapse Info</a>
        </div>
        <LabelledSelect className="small-12 medium-6 large-3 large-pull-3 columns" label="Status" labelStyle={{ lineHeight: 1.55 }} value={order.status_id} options={statuses} onChange={onUpdateOrder(order.order_id, 'status_id', order.status_id)} disabled={locked && !project.is_pod} />
        <LabelledInput className="small-12 medium-6 large-3 large-pull-3 columns"
          label="Sales Order Date" type="date" value={order.date_orderdate}
          onChange={this.onChangeOrder('date_orderdate')}
          onBlur={
            onUpdateOrder(order.order_id, 'date_orderdate', order.date_orderdate)}
          disabled={locked} />
        <LabelledTextArea className="small-12 columns" label="Introduction" value={intro} onChange={this.onChangeOrder('introduction')} onBlur={onUpdateOrder(order.order_id, 'introduction', order.introduction)} disabled={locked} style={{ minWidth: '100%' }} />
        <LabelledAddress
          className="small-12 medium-6 large-3 columns"
          label="Billing Address"
          address={billing_address}
          contact={billing_contact}
          onChangeContact={onUpdateBillingContact(order.order_id, order.billing_contact_id, order.billing_address_id)}
          onChangeAddress={onUpdateOrder(order.order_id, 'billing_address_id', order.billing_address_id)}
          addresses={billingAddresses}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddAddress={onAddAddress(order.order_id, 'billing_address_id', order.billing_address_id, 'BILLING')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'billing_contact_id', order.billing_contact_id)}
        />
        <LabelledAddress
          className="small-12 medium-6 large-3 columns"
          label="Main Shipping Address"
          address={shipping_address}
          contact={shipping_contact}
          onChangeContact={onUpdateShippingContact(order.order_id, order.shipping_contact_id, order.shipping_address_id)}
          onChangeAddress={onUpdateShippingAddress(order.order_id, order.shipping_address_id)}
          addresses={shippingAddresses}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddAddress={onAddAddress(order.order_id, 'shipping_address_id', order.shipping_address_id, 'SHIPPING')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'shipping_contact_id', order.shipping_contact_id)}
        />
        <LabelledSelect className="small-12 medium-6 large-3 columns" label="Terms" value={order.terms_id} options={terms} onChange={onUpdateOrder(order.order_id, 'terms_id', order.terms_id)} disabled={locked} />
        <LabelledSelect className="small-12 medium-6 large-3 columns" label="Currency" value={order.currency_id} options={currencies} onChange={onUpdateOrder(order.order_id, 'currency_id', order.currency_id)} disabled={true} />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="In Hands Date" type="date" value={order.date_inhandsdate} onChange={this.onChangeOrder('date_inhandsdate')} onBlur={onUpdateOrder(order.order_id, 'date_inhandsdate', order.date_inhandsdate)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Default Margin" type="text" disabled={true} value={order.default_margin} onBlur={onUpdateOrder(order.order_id, 'default_margin', order.default_margin)} />
        {this.renderTaxInput()}
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Customer PO" type="text" value={order.customer_po} onBlur={onUpdateOrder(order.order_id, 'customer_po', order.customer_po)} onChange={this.onChangeOrder('customer_po')} disabled={locked} />

        <LabelledCheckbox className="small-12 medium-6 large-3 columns" label="This is a sample order" value={order.sample_order} onChange={onUpdateOrder(order.order_id, 'sample_order', order.sample_order)} disabled={locked} />
      </div>
    );
  }

  renderInvoiceInfo() {
    const { order } = this.state;
    const {
      project,
      billing_address,
      billing_contact,
      shipping_address,
      shipping_contact,
      shippingAddresses,
      billingAddresses,
      contacts,
      statuses,
      currencies,
      terms,
      credit_card_payable,
      stripe_cc_payable,
      stripe_ach_payable,
      forward_payment_cc,
      forward_payment_ach,
      onUpdateOrder,
      onUpdateBillingContact,
      onUpdateShippingContact,
      onUpdateShippingAddress,
      onAddAddress,
      onAddContact,
    } = this.props;
    const locked = 1 == order.locked;
    const intro = order && order.introduction ? (order.introduction).replace(/\<br \/?>/g, "") : '';
    const showAllowCreditCard = credit_card_payable === CREDIT_CARD_PROVIDERS.CARDCONNECT.value
      || (credit_card_payable === CREDIT_CARD_PROVIDERS.STRIPE.value && stripe_cc_payable)
      || (credit_card_payable === CREDIT_CARD_PROVIDERS.COMMONSKU_PAYMENTS.value && forward_payment_cc);
    const showAllowAch = order.order_type === 'INVOICE' && (
      (credit_card_payable === CREDIT_CARD_PROVIDERS.STRIPE.value && stripe_ach_payable)
      || (credit_card_payable === CREDIT_CARD_PROVIDERS.COMMONSKU_PAYMENTS.value && forward_payment_ach)
    );

    return (
      <div>
        <div className="small-12 large-3 large-push-9 columns">
          <a className="hollow button trigger-button" style={{ float: 'right' }} onClick={this.handleToggleCollapse}>- Collapse Info</a>
        </div>
        <LabelledSelect className="small-12 medium-6 large-3 large-pull-3 columns" label="Status" labelStyle={{ lineHeight: 1.55 }} value={order.status_id} options={statuses} onChange={onUpdateOrder(order.order_id, 'status_id', order.status_id)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 large-pull-3 columns" label="Invoice Date" type="date" value={order.date_orderdate} onChange={this.onChangeOrder('date_orderdate')} onBlur={onUpdateOrder(order.order_id, 'date_orderdate', order.date_orderdate)} disabled={locked} />
        <LabelledTextArea className="small-12 columns" label="Introduction" value={intro} onChange={this.onChangeOrder('introduction')} onBlur={onUpdateOrder(order.order_id, 'introduction', order.introduction)} disabled={locked} style={{ minWidth: '100%' }} />
        <LabelledAddress
          className="small-12 medium-6 large-3 columns"
          style={{ minHeight: '240px' }}
          label="Billing Address"
          address={billing_address}
          contact={billing_contact}
          onChangeContact={onUpdateBillingContact(order.order_id, order.billing_contact_id, order.billing_address_id)}
          onChangeAddress={onUpdateOrder(order.order_id, 'billing_address_id', order.billing_address_id)}
          addresses={billingAddresses}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddAddress={onAddAddress(order.order_id, 'billing_address_id', order.billing_address_id, 'BILLING')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'billing_contact_id', order.billing_contact_id)}
        />
        <LabelledAddress
          className="small-12 medium-6 large-3 columns"
          style={{ minHeight: '240px' }}
          label="Main Shipping Address"
          address={shipping_address}
          contact={shipping_contact}
          onChangeContact={onUpdateShippingContact(order.order_id, order.shipping_contact_id, order.shipping_address_id)}
          onChangeAddress={onUpdateShippingAddress(order.order_id, order.shipping_address_id)}
          addresses={shippingAddresses}
          contacts={contacts}
          disabled={locked}
          canCreate={this.hasCapability('MODIFY-DOWNSTREAM-ACCOUNT')}
          onAddAddress={onAddAddress(order.order_id, 'shipping_address_id', order.shipping_address_id, 'SHIPPING')}
          onAddContact={onAddContact(order.order_id, project.account_id, 'shipping_contact_id', order.shipping_contact_id)}
        />
        <LabelledSelect className="small-12 medium-6 large-3 columns" label="Terms" value={order.terms_id} options={terms} onChange={onUpdateOrder(order.order_id, 'terms_id', order.terms_id)} disabled={locked} />
        <LabelledSelect className="small-12 medium-6 large-3 columns" label="Currency" value={order.currency_id} options={currencies} onChange={onUpdateOrder(order.order_id, 'currency_id', order.currency_id)} disabled={true} />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="In Hands Date" type="date" value={order.date_inhandsdate} onChange={this.onChangeOrder('date_inhandsdate')} onBlur={onUpdateOrder(order.order_id, 'date_inhandsdate', order.date_inhandsdate)} disabled={locked} />
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Default Margin" type="text" disabled={true} value={order.default_margin} onBlur={onUpdateOrder(order.order_id, 'default_margin', order.default_margin)} />
        {this.renderTaxInput()}
        <LabelledInput className="small-12 medium-6 large-3 columns" label="Customer PO" type="text" value={order.customer_po} onBlur={onUpdateOrder(order.order_id, 'customer_po', order.customer_po)} onChange={this.onChangeOrder('customer_po')} disabled={locked} />
        <LabelledRadio className="small-12 medium-6 large-3 columns" label="Invoice View" value={order.view_type} options={INVOICE_VIEW_TYPES} onChange={onUpdateOrder(order.order_id, 'view_type', order.view_type)} disabled={locked} />
        {showAllowCreditCard &&
          <div className="small-12 medium-6 large-3 columns">
            <LabelledCheckbox
              label="Allow Credit Card"
              value={order.allow_cc_payment}
              onChange={onUpdateOrder(order.order_id, 'allow_cc_payment', order.allow_cc_payment)}
              disabled={locked}
            />
            <OrderCreditCardFeeEditHandle order={order} project={project} />
          </div>}
        {showAllowAch && <LabelledCheckbox className="small-12 medium-6 large-3 columns" label="Allow ACH" value={order.allow_ach_payment} onChange={onUpdateOrder(order.order_id, 'allow_ach_payment', order.allow_ach_payment)} disabled={locked} />}
      </div>
    );
  }

  hasCapability(capability) {
    return this.props.identity.capabilities.includes(capability);
  }

  renderLoading() {
    return (
      <div className="main-content project-order" style={{ textAlign: 'center' }}>
        <img style={{ marginTop: '2rem' }} src="/images/gears.gif" />
      </div>
    );
  }

  renderPendingPayment(message) {
    return (
      <div className="main-content project-order">
        <AlertNotification alertType="error">
          {message ? message : <>Order can not be loaded. Please check back later.</>}
        </AlertNotification>
      </div>
    );
  }

  exportPartialsCSV(selected = this.state.selected_partials) {
    const obj = {
      'report_type': 'partials',
      'export_all': true,
      'form_number': this.state.order.form_number,
      'order_ids': JSON.stringify(selected)
    };

    if (selected.length < 50) {
      openWindowWithPost("/export_report.php", obj);
    } else {
      oauth('POST', `export-report-task`, obj).then(({ json }) => {
        this.setState((prev) => {
          return {
            ...prev,
            exportTaskIds: [...prev.exportTaskIds, json.export_report_task.export_report_task_id],
          };
        });
      });
    }
  }

  exportPartialsPDF(selected) {
    if (!selected.length) return;
    const obj = {
      'print_checkouts': 1,
      'actionName': 'partials-pdf',
      'report_type': 'partials',
      'shop_id': this.props.order.shop_id,
      'order_ids': JSON.stringify(selected)
    };

    if (selected.length < 50) {
      const formData = new FormData();
      for (let key in obj) {
        if (key === 'order_ids') {
          selected.forEach(v => {
            formData.append('order_ids[]', v);
          });
        } else {
          formData.append(key, obj[key]);
        }
      }
      this.setState({ exportingPdf: true, });
      oauth('POST', 'export', {}, formData, { headers: { 'Accept': 'application/pdf' } }, (response) => {
        if (!response.ok) {
          return 'Unable to generate PDF';
        }
        return response.blob();
      }).then((file) => {
        this.setState({ exportPdfFile: file });
      }).catch(() => {
        this.setState({ exportPdfFile: 'Unable to generate PDF' });
      });
    } else {
      oauth('POST', 'export-report-task', obj).then(({ json }) => {
        this.setState((prev) => {
          const exportReportTask = json?.export_report_task;
          const isComplete = Boolean(exportReportTask?.result) ||
            Boolean(exportReportTask?.date_finished) ||
            Boolean(exportReportTask?.error) ||
            Boolean(exportReportTask?.date_failed);
          return {
            ...prev,
            exportingPdf: !isComplete,
            exportReportTask: exportReportTask,
          };
        });
      });
    }
  }

  handleLoadPartials() {
    const { order, onLoadPartials } = this.props;
    const { partials_loaded } = this.state;
    if (!partials_loaded) {
      onLoadPartials(order.job_id).then(() => {
        this.setState({ partials_loaded: true });
      });
    }
  }

  handleClickPartial(order_id) {
    const { selected_partials } = this.state;

    if (selected_partials.includes(order_id)) {
      this.setState({ selected_partials: selected_partials.filter(id => id !== order_id) });
    } else {
      this.setState({ selected_partials: selected_partials.concat(order_id) });
    }
  }

  handleSelectAllPartials(checked) {
    if (checked) {
      this.setState({ selected_partials: [] });
    } else {
      this.setState({ selected_partials: this.props.partials.map(o => o.order_id) });
    }
  }

  handleClickRefund(order_id) {
    const { selected_refunds } = this.state;

    if (selected_refunds.includes(order_id)) {
      this.setState({ selected_refunds: selected_refunds.filter(id => id !== order_id) });
    } else {
      this.setState({ selected_refunds: selected_refunds.concat(order_id) });
    }
  }

  handleSelectAllRefunds(checked) {
    if (checked) {
      this.setState({ selected_refunds: [] });
    } else {
      this.setState({ selected_refunds: this.props.refunded_partials.map(o => o.order_id) });
    }
  }

  handleRemovePartials() {
    const { order, selected_partials } = this.state;
    const { onCreateRemovePartials, identity } = this.props;
    const { hasUserFlags } = getIdentityUtils(identity);
    const hasCommonskuPaymentsFlag = hasUserFlags(FLAG_COMMONSKU_PAYMENTS);

    this.setState({ in_aggregating: true }, function () {
      onCreateRemovePartials(selected_partials, order.order_id, hasCommonskuPaymentsFlag);
      this.checkShopAggregateStatus();
    });
  }

  submitRefund(paymentIds, { loadingKey, errorKey, defaultErrorMessage, onSuccess = {} }) {
    this.setState({ [loadingKey]: true, [errorKey]: null });

    oauth('POST', 'forward-payments/refund', {
      payment_ids: paymentIds,
      delete_on_refund: false,
    }).then(
      ({ json }) => {
        const hasUntrackedFailure = (json?.results || []).some(r => !REFUND_TRACKED_OUTCOMES.includes(r.outcome));

        this.setState({
          [loadingKey]: false,
          partials_loaded: false,
          [errorKey]: hasUntrackedFailure ? defaultErrorMessage : null,
          ...(hasUntrackedFailure ? {} : onSuccess),
        }, () => this.handleLoadPartials());
      },
      ({ json }) => {
        this.setState({
          [loadingKey]: false,
          [errorKey]: json?.errors?.[0] || defaultErrorMessage,
        });
      }
    );
  }

  handleRefundCheckouts() {
    const { partials } = this.props;
    const { selected_partials } = this.state;

    const paymentIds = partials
      .filter(o => selected_partials.includes(o.order_id) && o.payment_provider === CREDIT_CARD_PROVIDERS.COMMONSKU_PAYMENTS.value)
      .map(o => o.payment_id)
      .filter(Boolean);

    if (!paymentIds.length) {
      this.setState({ showPopup: '' });
      return;
    }

    this.submitRefund(paymentIds, {
      loadingKey: 'refundingCheckouts',
      errorKey: 'refundCheckoutsError',
      defaultErrorMessage: 'Something went wrong refunding the selected checkout(s). Please try again.',
      onSuccess: { showPopup: '', selected_partials: [] },
    });
  }

  handleRetryFailedRefunds(failedPartials) {
    const paymentIds = failedPartials.map(o => o.payment_id).filter(Boolean);

    if (!paymentIds.length) {
      return;
    }

    this.submitRefund(paymentIds, {
      loadingKey: 'retryingRefunds',
      errorKey: 'retryRefundsError',
      defaultErrorMessage: 'Something went wrong retrying the refund(s). Please try again.',
    });
  }

  render() {
    const { order, selected_partials, selected_refunds, partials_loaded, showPopup, exportShipstationErrorMessage, getStoresError } = this.state;

    if (!order.loaded) {
      if (order.hasError) {
        return this.renderPendingPayment(order.errorMessage);
      }
      return this.renderLoading();
    }

    const {
      location,
      services,
      project,
      deposit_invoice,
      onUpdateOrder,
      onAddDepositInvoice,
      onDeleteDepositInvoice,
      onUpdateDepositInvoice,
      onUpdateItemSummaryView,
      onUpdateItemSummaryTab,
      onUpdateItemSummaryShowActive,
      hidden_filter_status,
      product_list_style,
      tab,
      collapsed,
      identity,
      partials,
      refunded_partials,
      onCreatePartialPopup,
      onCreateErrorPopup,
      stripe_cc_payable,
      stripe_ach_payable,
      forward_payment_cc,
      forward_payment_ach,
      credit_card_payable,
      shipstation_api_v1_enabled,
      isPoDShopSalesOrder,
    } = this.props;

    const hasCapability = this.hasCapability;
    const { hasUserFlags } = getIdentityUtils(identity);
    const has_lockable_status = ['Invoiced', 'Paid', 'Exported'].includes(order.status_name);
    const has_unlock = order.bulk_update_margin_count === 0 && hasCapability(`UNLOCK-${order.order_type.replace(/ /g, '-')}`);

    const handleUnlockOrder = e => {
      e.preventDefault();
      if (!has_unlock) {
        return;
      }
      onUpdateOrder(order.order_id, 'locked', order.locked)(1 == order.locked ? 0 : 1);
    };

    const hasShipstationIntegration = shipstation_api_v1_enabled && hasCapability('HAS-SHIPSTATION');
    const selectedPartialsData = partials.filter(o => selected_partials.includes(o.order_id));
    const hasFailedRefunds = refunded_partials.some(o => o.refund_status === 'REFUND_FAILED');
    const hasCommonskuPaymentsCheckoutSelected = hasUserFlags(FLAG_COMMONSKU_PAYMENTS_QBO_REFUNDS_UI)
      && selectedPartialsData.some(o => o.payment_provider === CREDIT_CARD_PROVIDERS.COMMONSKU_PAYMENTS.value);

    return (
      <>
        <div className="main-content project-order">
          {!!order.bulk_update_margin_count && order.locked &&
            <AlertNotification mb={30} mr={15}>
              This order is locked while we are updating the margins on {order.bulk_update_margin_count} products. This may take a few minutes.
            </AlertNotification>
          }
          {
            config.sanmar.show_modal && find(order.items, { supplier_id: '9da87da3-7ce5-490d-9e0d-d59962ead31f' })
              ? <SanmarNotificationBar /> : null
          }
          {collapsed ? this.renderBasicInfo() :
            'PRESENTATION' === order.order_type ? this.renderPresentationInfo() :
              'ESTIMATE' === order.order_type ? this.renderEstimateInfo() :
                'SALES ORDER' === order.order_type ? this.renderSalesOrderInfo() :
                  this.renderInvoiceInfo()}
          <div className="small-12 columns">
            <ul className="switches">
              {'products' === tab ? <li>
                <div className="button-group compact-detailed-switch">
                  {'PRESENTATION' !== order.order_type ?
                    <a onClick={e => { e.preventDefault(); onUpdateItemSummaryView(order.order_id, 'compact'); }} className={'button' + ('compact' === product_list_style ? ' active' : '')}>Compact</a>
                    : null}
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryView(order.order_id, 'detailed'); }} className={'button' + ('detailed' === product_list_style ? ' active' : '')}>Detailed</a>
                  {'PRESENTATION' === order.order_type ?
                    <a onClick={e => { e.preventDefault(); onUpdateItemSummaryView(order.order_id, 'grid'); }} className={'button' + ('grid' === product_list_style ? ' active' : '')}>
                      Grid
                    </a> : null}
                </div>
              </li> : null}
              {'info' !== tab && 'SALES ORDER' !== order.order_type && 'INVOICE' !== order.order_type ? <li>
                <div className="button-group compact-detailed-switch">
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryShowActive(order.order_id, 'all'); }} className={'button' + ('all' === hidden_filter_status ? ' active' : '')}>Show All</a>
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryShowActive(order.order_id, 'active'); }} className={'button' + ('active' === hidden_filter_status ? ' active' : '')}>Show Active</a>
                </div>
              </li> : null}
              {!isPoDShopSalesOrder && (1 == order.locked || has_lockable_status) ? <li>
                <div className="button-group compact-detailed-switch">
                  <a onClick={handleUnlockOrder} className={'button' + (1 == order.locked ? ' active' : '')}>Locked</a>
                  {has_unlock ? <a onClick={handleUnlockOrder} className={'button' + (0 == order.locked ? ' active' : '')}>Unlocked</a> : null}
                </div>
              </li> : null}
            </ul>
            <ul className="tabs" id="order-tabs">
              {
                isPoDShopSalesOrder ? null : (
                  <li className={'tabs-title' + ('products' === tab ? ' is-active' : '')}>
                    <a onClick={e => { e.preventDefault(); onUpdateItemSummaryTab(order.order_id, 'products'); }} aria-selected={'products' === tab}>Products</a>
                  </li>
                )
              }
              {'ESTIMATE' === order.order_type || 'SALES ORDER' === order.order_type || 'PRESENTATION' === order.order_type || 'COLLECTION' === order.order_type ?
                <li className={'tabs-title' + ('artwork' === tab ? ' is-active' : '')}>
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryTab(order.order_id, 'artwork'); }} aria-selected={'artwork' === tab}>Artwork</a>
                </li>
                : null}
              {'PRESENTATION' === order.order_type ?
                <li className={'tabs-title' + ('comment' === tab ? ' is-active' : '')} style={{ 'display': 'none' }}>
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryTab(order.order_id, 'comment'); }} aria-selected={'comment' === tab}>Comment</a>
                </li>
                : null}
              {'SALES ORDER' === order.order_type && order.is_aggregate == 1 ?
                <li className={'tabs-title' + ('partial' === tab ? ' is-active' : '')}>
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryTab(order.order_id, 'partial'); this.handleLoadPartials(); }} aria-selected={'partial' === tab}>Checkouts</a>
                </li>
                : null}
              {'SALES ORDER' === order.order_type && order.is_aggregate == 1 && hasUserFlags(FLAG_COMMONSKU_PAYMENTS) ?
                <li className={'tabs-title' + ('refunds' === tab ? ' is-active' : '')}>
                  <a onClick={e => { e.preventDefault(); onUpdateItemSummaryTab(order.order_id, 'refunds'); this.handleLoadPartials(); }} aria-selected={'refunds' === tab}>
                    Refunds
                    {hasFailedRefunds && hasUserFlags(FLAG_COMMONSKU_PAYMENTS_QBO_REFUNDS_UI) &&
                      <RefundTabAlertIcon size="medium" color={colors.errors.main} />
                    }
                  </a>
                </li>
                : null}
              {'INVOICE' === order.order_type && (
                <li className={'tabs-title' + ('credit-memo' === tab ? ' is-active' : '')}>
                  <a onClick={e => {
                    e.preventDefault();
                    onUpdateItemSummaryTab(order.order_id, 'credit-memo');
                    this.handleLoadPartials();
                  }}
                    aria-selected={'credit-memo' === tab}
                  >
                    Credit Memos
                  </a>
                </li>
              )}
              {tab === 'partial' && selected_partials.length && order.locked == 0 && project.purchase_orders.length === 0 ?
                <Button size='small' variant='error' style={{ margin: '15px 0px 0px 0px', float: 'right' }} onClick={e => { e.preventDefault(); this.state.in_aggregating ? onCreateErrorPopup() : this.handleRemovePartials(); }}>Remove Checkouts</Button>
                : null}
              {tab === 'partial' && selected_partials.length && order.locked == 0 && hasCommonskuPaymentsCheckoutSelected ?
                <RefundCheckoutsButton size='small' variant='error' onClick={e => { e.preventDefault(); this.handleShowPopup('RefundCheckoutsPopup'); }}>Refund Checkouts</RefundCheckoutsButton>
                : null}
              {tab === 'partial' && selected_partials.length ?
                <Dropdown
                  style={{ margin: '15px 10px 0px 0px', float: 'right' }}
                  buttonProps={{ disabled: !selected_partials.length }}
                  buttonVariant='primary'
                  size='small'
                  text="Export Checkouts"
                  items={[
                    {
                      onClick: e => { e.preventDefault(); this.exportPartialsCSV(); },
                      content: "Export CSV",
                      active: selected_partials.length > 0,
                      show: selected_partials.length > 0,
                    },
                    {
                      onClick: e => { e.preventDefault(); this.exportPartialsPDF(selected_partials); },
                      content: "Export PDF",
                      active: selected_partials.length > 0,
                      show: selected_partials.length > 0,
                    },
                    hasShipstationIntegration && {
                      onClick: e => { e?.preventDefault?.(); this.handleShowPopup('ExportToShipStationPopup'); },
                      content: "Export to ShipStation",
                      active: selected_partials.length > 0,
                      show: selected_partials.length > 0,
                    },
                  ]} />
                : null}
              {tab === 'partial' && selected_partials.length ?
                <Button size='small' style={{ margin: '15px 10px 0px 0px', float: 'right' }} onClick={e => { e.preventDefault(); onCreatePartialPopup(selected_partials); }}>View Checkouts</Button>
                : null}
              {tab === 'refunds' && selected_refunds.length ?
                <Dropdown
                  style={{ margin: '15px 10px 0px 0px', float: 'right' }}
                  buttonProps={{ disabled: !selected_refunds.length }}
                  buttonVariant='primary'
                  size='small'
                  text="Export Checkouts"
                  items={[
                    {
                      onClick: e => { e.preventDefault(); this.exportPartialsCSV(selected_refunds); },
                      content: "Export CSV",
                      active: selected_refunds.length > 0,
                      show: selected_refunds.length > 0,
                    },
                    {
                      onClick: e => { e.preventDefault(); this.exportPartialsPDF(selected_refunds); },
                      content: "Export PDF",
                      active: selected_refunds.length > 0,
                      show: selected_refunds.length > 0,
                    },
                  ]} />
                : null}
              {tab === 'refunds' && selected_refunds.length ?
                <Button size='small' style={{ margin: '15px 10px 0px 0px', float: 'right' }} onClick={e => { e.preventDefault(); onCreatePartialPopup(selected_refunds); }}>View Checkouts</Button>
                : null}
            </ul>
            <div className="tabs-content" data-tabs-content="order-tabs">
              <div className="tabs-panel is-active">
                {'partial' === tab ?
                  <PartialList
                    partials_loaded={partials_loaded}
                    partials={partials}
                    selected={selected_partials}
                    handleClickPartial={this.handleClickPartial}
                    handleSelectAllPartials={this.handleSelectAllPartials}
                  />
                  : ('refunds' === tab ?
                    // partials_loaded is reused here: refunds and partials come from the same handleLoadPartials fetch, just split by refund_status
                    <PartialList
                      partials_loaded={partials_loaded}
                      partials={refunded_partials}
                      selected={selected_refunds}
                      handleClickPartial={this.handleClickRefund}
                      handleSelectAllPartials={this.handleSelectAllRefunds}
                      emptyMessage="No refunds."
                      onRetryFailedRefunds={hasUserFlags(FLAG_COMMONSKU_PAYMENTS_QBO_REFUNDS_UI) ? this.handleRetryFailedRefunds : undefined}
                      retryingRefunds={this.state.retryingRefunds}
                      retryRefundsError={this.state.retryRefundsError}
                    />
                  : ('credit-memo' === tab ?
                    <ReportProvider
                      reportConfig={this.reportConfig}
                      defaultFilters={this.creditMemoReportFilter}
                    >
                      <ReportTableContainer>
                        <ReportTable />
                        <Pagination />
                        <Loading />
                      </ReportTableContainer>
                    </ReportProvider> :
                    <ItemList
                      convertibleProducts={this.props.convertibleProducts}
                      hasPSUpgradeProductEnabled={this.props.hasPSUpgradeProductEnabled}
                      checkBulkUpdateMarginStatus={this.checkBulkUpdateMarginStatus}
                      clientId={order.client_id}
                      key={order.order_id}
                      location={location}
                      order_id={order.order_id}
                      order_type={order.order_type}
                      order_currency_id={order.currency_id}
                      items={order.items}
                      services={services}
                      display={'artwork' === tab || 'comment' === tab ? tab : product_list_style}
                      hidden_filter_status={hidden_filter_status}
                      locked={1 == order.locked}
                      hideAddItemActions={isPoDShopSalesOrder}
                      is_aggregate_so={1 == order.is_aggregate && order.order_type === 'SALES ORDER'}
                      upgradingByItemId={this.state.upgradingByItemId}
                      upgradeFailedByItemId={this.state.upgradeFailedByItemId}
                      onUpgradeItem={(item, psProduct) => this.setState({ upgradeProduct: { item, psProduct } })}
                    />))
                }
              </div>
            </div>
            {
              (order.items.length > 0 && 'credit-memo' !== tab) &&
              <div className="row collapse" style={{ maxWidth: 'initial' }}>
                {'INVOICE' === order.order_type ?
                  <ProjectMarginSummary project={project} order_id={order.parent_order_id} /> :
                  'SALES ORDER' === order.order_type || 'ESTIMATE' === order.order_type ?
                    <OrderMarginSummary order={order} /> :
                    null}
                {'INVOICE' === order.order_type || 'SALES ORDER' === order.order_type || 'ESTIMATE' === order.order_type ?
                  <div className="large-4 columns">&nbsp;</div> :
                  <div className="large-8 columns">&nbsp;</div>}
                {'PRESENTATION' !== order.order_type && 'products' === tab ? <OrderSummary project={project} stripe_cc_payable={stripe_cc_payable} stripe_ach_payable={stripe_ach_payable} forward_payment_cc={forward_payment_cc} forward_payment_ach={forward_payment_ach} credit_card_payable={credit_card_payable} order={order} onUpdateOrder={onUpdateOrder} onAddDepositInvoice={onAddDepositInvoice} onUpdateDepositInvoice={onUpdateDepositInvoice} onDeleteDepositInvoice={onDeleteDepositInvoice} deposit_invoice={deposit_invoice} identity={identity} /> : null}
              </div>
            }
          </div>
          {this.state.exportingPdf
            ? <ExportViewerPopup
              onClose={() => this.setState({ exportingPdf: false, exportPdfFile: undefined, exportReportTask: null, })}
              exportTask={this.state.exportReportTask}
              file={this.state.exportPdfFile}
            />
            : (
              this.state.exportTaskIds.length > 0
                ? <ExportViewerPortal>
                  <ExportViewer exportTaskIds={this.state.exportTaskIds} />
                </ExportViewerPortal>
                : null
            )}
          {this.state.upgradeProduct ? <UpgradeProductPopup
            onClose={() => this.setState({ upgradeProduct: null })}
            onQueued={({ order_id, item_id }) => this.handleUpgradeQueued({ order_id, item_id })}
            item={this.state.upgradeProduct.item}
            product={this.state.upgradeProduct.psProduct} />
            : null}
        </div>
        {showPopup === 'RefundCheckoutsPopup' && <RefundCheckoutsPopup
          selectedCheckouts={selectedPartialsData}
          hasPurchaseOrders={project.purchase_orders.length > 0}
          confirmLoading={this.state.refundingCheckouts}
          errorMessage={this.state.refundCheckoutsError}
          onClose={() => this.setState({ showPopup: '', refundCheckoutsError: null })}
          onConfirm={this.handleRefundCheckouts}
        />}
        {showPopup === 'ExportToShipStationPopup' && <ExportToShipStationPopup ordersIds={selected_partials} handleShowPopup={this.handleShowPopup} />}
        {showPopup === 'ExportToShipStationStatusPopup' && <ExportToShipStationStatusPopup handleShowPopup={this.handleShowPopup} errorMessage={exportShipstationErrorMessage} getStoresError={getStoresError} />}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadOrder: (order_id, force = false) => dispatch(createLoadOrder(order_id, force)),
    onAddAddress: (order_id, field, previous_value, address_type) => () => {
      dispatch(createAddAddressPopup(order_id, field, previous_value, ownProps.project.account.account_id, 'CLIENT', null, null, address_type));
    },
    onAddContact: (order_id, account_id, field, previous_value) => () => {
      dispatch(createAddContactPopup(order_id, account_id, field, previous_value, ownProps.project.account.account_id, 'CLIENT'));
    },
    onUpdateBillingContact: (order_id, previous_contact_id, previous_address_id, contact_id) => contact_id => {
      dispatch(updateOrderContact('billing')(order_id, previous_contact_id, previous_address_id, contact_id));
    },
    onUpdateShippingContact: (order_id, previous_contact_id, previous_address_id, contact_id) => contact_id => {
      dispatch(updateOrderContact('shipping')(order_id, previous_contact_id, previous_address_id, contact_id));
    },
    onUpdateShippingAddress: (order_id, previous_address_id) => address_id => {
      dispatch(updateOrderAddress('shipping')(order_id, previous_address_id, address_id));
    },
    onUpdateOrder: (order_id, field, previous_value) => value => {
      if (field === 'status_id' && value === '') {
        return;
      }

      dispatch(updateOrder(order_id, field, previous_value, value));
    },
    onAddDepositInvoice: (job_id, order_id) => {
      dispatch(createAddDepositInvoice(job_id, order_id));
    },
    onDeleteDepositInvoice: (deposit_id) => {
      dispatch(createDeleteDepositInvoice(deposit_id));
    },
    onUpdateDepositInvoice: (deposit_id, field, previous_value) => value => {
      dispatch(createUpdateDepositInvoice(deposit_id, field, previous_value, value));
    },
    onUpdateItemSummaryView: (order_id, view_type) => {
      dispatch(createUpdateDisplayItemSummaryView(order_id, view_type));
    },
    onUpdateItemSummaryTab: (order_id, tab) => {
      dispatch(createUpdateDisplayItemSummaryTab(order_id, tab));
    },
    onUpdateItemSummaryShowActive: (order_id, filter) => {
      dispatch(createUpdateDisplayItemSummaryShowActive(order_id, filter));
    },
    onUpdateCollapsed: (order_id, collapsed) => {
      dispatch(createUpdateCollapseOrderInfo(order_id, collapsed));
    },
    onCreatePartialPopup: order_ids => dispatch(createPartialPopup(order_ids)),
    onCreateRemovePartials: (order_ids, order_id, hasCommonskuPaymentsFlag) => {
      const message = hasCommonskuPaymentsFlag ? 'Remove checkout' : 'You Sure?';
      const confirmLabel = hasCommonskuPaymentsFlag ? 'Remove checkout' : undefined;
      const cancelLabel = hasCommonskuPaymentsFlag ? 'Cancel' : undefined;
      dispatch(createValidateConfirmationPopup(() => {
        return dispatch(createRemovePartials(order_ids, order_id));
      }, [], message, 'Selected checkout(s) will be moved back to the Shop Checkout areas.  You may delete them from there if they are no longer required.', true, confirmLabel, cancelLabel));
    },
    onCreateErrorPopup: () => dispatch(createErrorPopup('There is a removing checkouts process running for this shop. Please wait for it to finish first.')),
    onCreateNoticePopup: () => dispatch(createNoticePopup('Removing checkouts is in progress. It may take a while so please grab a coffee.')),
    onCreateClosePopup: () => dispatch(closePopup()),
    onLoadPartials: job_id => dispatch(createLoadPartialList(job_id)),
    onGetUpgradePromoStandardsProductTaskStatus: (item_id, order_id) => dispatch(getUpgradePromoStandardsProductTaskStatus(item_id, order_id)),
    fetchConvertibleProducts: (nonPSItems) => dispatch(getConvertibleProducts(nonPSItems)),
    removeConvertibleByKey: (promo_api_name, item_sku) => dispatch(removeConvertible({ promo_api_name, item_sku })),
  };
};

const mapStateToProps = (state, ownProps) => {
  const order = getOrderByNumber(state, { form_number: ownProps.order.form_number, order_type: ownProps.order.order_type });
  const project = ownProps.project;
  const deposit_invoice = Object.values(state.entities.deposit_invoices).filter(d => d.order_id === order.order_id)[0];
  const order_display = Object.assign({}, {
    item_summary_view: 'detailed',
    item_summary_show_active: 'all',
    item_summary_tab: 'products',
    collapsed: false
  }, state.display.orders[order.order_id]);
  const product_list_style = order_display.item_summary_view;
  const isPoDShopSalesOrder = order.order_type === 'SALES ORDER' && !!project.is_pod;
  const tab = isPoDShopSalesOrder && order_display.item_summary_tab === 'products' ? 'artwork' : order_display.item_summary_tab;
  const collapsed = order_display.collapsed;
  const all_partials = Object.values(state.entities.orders).filter(o => o.order_type === 'PARTIAL' && o.parent_order_id === order.order_id);
  const partials = all_partials.filter(o => !REFUNDS_TAB_STATUSES.includes(o.refund_status));
  const refunded_partials = all_partials.filter(o => REFUNDS_TAB_STATUSES.includes(o.refund_status));
  const companyData = state.entities.company_data[state.identity.company_id];
  const credit_card_payable = companyData.credit_card_payable;
  const stripe_cc_payable = companyData.stripe_cc_payable;
  const stripe_ach_payable = companyData.stripe_ach_payable;
  const forward_payment_cc = companyData.forward_payment_cc;
  const forward_payment_ach = companyData.forward_payment_ach;
  const shipstation_api_v1_enabled = companyData.shipstation_api_v1_enabled;
  const hasPSUpgradeProductEnabled = order.order_type === 'SALES ORDER';
  const convertibleProducts = hasPSUpgradeProductEnabled ? state.entities.convertibleProducts?.products : [];
  const convertibleProductsLoading = hasPSUpgradeProductEnabled ? state.entities.convertibleProducts?.loading === 'pending' : false;
  return {
    identity: state.identity ?? false,
    order: order,
    collapsed,
    product_list_style,
    hidden_filter_status: order_display.item_summary_show_active,
    tab,
    isPoDShopSalesOrder,
    billing_address: getAddress(state, { address_id: order.billing_address_id }),
    billing_contact: getContact(state, { contact_id: order.billing_contact_id }),
    shipping_address: getAddress(state, { address_id: order.shipping_address_id }),
    shipping_contact: getContact(state, { contact_id: order.shipping_contact_id }),
    shippingAddresses: getShippingAddressOptions(state, { parent_id: project.account_id }),
    billingAddresses: getBillingAddressOptions(state, { parent_id: project.account_id }),
    contacts: getContactOptions(state, { parent_id: project.account_id }),
    statuses: getStatusOptions(state, order),
    services: getServiceOptions(state),
    currencies: getCurrencyOptions(state),
    terms: getTermsOptions(state),
    taxes: getTaxOptions(state),
    project: project,
    /* mapStateToProps should not allocate new function,
     * it will cause re-render on every action.
     * move hasCapability inside Component for now,
     * should switch to the one in util.js
     * */
    deposit_invoice: deposit_invoice,
    partials: partials,
    refunded_partials: refunded_partials,
    credit_card_payable,
    stripe_cc_payable,
    stripe_ach_payable,
    forward_payment_cc,
    forward_payment_ach,
    shipstation_api_v1_enabled,
    splitShip: selectSplitShip(state),
    convertibleProducts,
    convertibleProductsLoading,
    hasPSUpgradeProductEnabled,
  };

};

export default withReducers(connect(mapStateToProps, mapDispatchToProps)(ProjectOrder), {
  [SplitShipSlice.name]: SplitShipSlice.reducer,
});
